// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { LoginService } from '@client/app/core/services/login/login.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { PipeService } from '../../../../../filters/pipe-transformation.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MON_MODULES } from '@monsido/core/constants/mon-modules.constant';

@Component({
    selector: 'page-details-section-dashboard',
    standalone: false,
    template: `
        <div id="page-details-dashboard" class="px-6" *ngIf="!loading">
            <h3 class="font-weight-300 mb-4">
                <span class="fas fa-id-card mr-2 text-link" aria-hidden="true"></span>
                <span translate>Page Dashboard</span>
            </h3>
            <div class="row">
                <!-- Module Section BEGIN-->
                <div class="col-48" [ngClass]="{'col-lg-30': showStatistics && (authUser | hasAccess: modules.statistics)}">
                    <div class="row align-items-stretch">
                        <div class="col-48 col-sm-24 pb-3" *ngIf="(authUser | hasAccess: modules.qa) && showQA">
                            <div class="card panel-monsido-card mb-3 max-height d-flex flex-column justify-content-between">
                                <div class="card-header py-3">
                                    <h2 class="card-title font-weight-300 mt-0">
                                        <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'QA'] | monIcons" aria-hidden="true"></span>
                                        <span translate>Quality Assurance</span>
                                    </h2>
                                </div>
                                <div class="card-body py-0">
                                    <page-details-dashboard-charts-qa [page]="page" (onClickHandler)="navigateTo($event.params)">
                                    </page-details-dashboard-charts-qa>
                                </div>
                                <div class="card-footer text-right bg-white">
                                    <a class="font-size-1-1" role="button" (click)="navigateTo({target: 'page-details-section-qa'})" translate>
                                        QUALITY ASSURANCE
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-48 col-sm-24 pb-3" *ngIf="showPolicy && (authUser | hasAccess: modules.policies)">
                            <div class="card panel-monsido-card mb-3 max-height d-flex flex-column justify-content-between">
                                <div class="card-header py-3">
                                    <h2 class="card-title font-weight-300 mt-0">
                                        <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'POLICIES'] | monIcons" aria-hidden="true"></span>
                                        <span translate>Content Policy Violations</span>
                                    </h2>
                                </div>
                                <div class="card-body">
                                    <page-details-dashboard-charts-policies [page]="page" (onClickHandler)="navigateTo($event.params)"></page-details-dashboard-charts-policies>
                                </div>
                                <div class="card-footer text-right bg-white">
                                    <a class="font-size-1-1" role="button" (click)="navigateTo({target: 'page-details-section-policies'})" translate>
                                        POLICIES OVERVIEW
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-48 col-sm-24 pb-3" *ngIf="showAccessibility && (authUser | hasAccess: modules.accessibility)">
                            <div class="card panel-monsido-card mb-3 max-height d-flex flex-column justify-content-between">
                                <div class="card-header py-3">
                                    <h2 class="card-title font-weight-300 mt-0">
                                        <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'ACCESSIBILITY'] | monIcons" aria-hidden="true"></span>
                                        <span translate>Accessibility</span>
                                    </h2>
                                </div>
                                <div class="card-body">
                                    <page-details-dashboard-charts-accessibility [page]="page" (onClickHandler)="navigateTo($event.params)">
                                    </page-details-dashboard-charts-accessibility>
                                </div>
                                <div class="card-footer text-right bg-white">
                                    <a class="font-size-1-1" role="button" (click)="navigateTo({target: 'page-details-section-accessibility'})" translate>
                                        ACCESSIBILITY OVERVIEW
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-48 col-sm-24 pb-3" *ngIf="showSEO && authUser | hasAccess: modules.seo">
                            <div class="card panel-monsido-card mb-3 max-height d-flex flex-column justify-content-between">
                                <div class="card-header py-3">
                                    <h2 class="card-title font-weight-300 mt-0">
                                        <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'SEO'] | monIcons" aria-hidden="true"></span>
                                        <span translate>Search Engine Optimization (SEO)</span>
                                    </h2>
                                </div>
                                <div class="card-body">
                                    <page-details-dashboard-charts-seo [page]="page" (onClickHandler)="navigateTo($event.params)"></page-details-dashboard-charts-seo>
                                </div>
                                <div class="card-footer text-right bg-white">
                                    <a class="font-size-1-1" role="button" (click)="navigateTo({target: 'page-details-section-seo'})" translate>
                                        SEO OVERVIEW
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-48 col-sm-24 pb-3" *ngIf="'page_page_performance' | domainActiveFeature:null:page && (authUser | hasAccess: modules.performance)">
                            <div class="card panel-monsido-card mb-3 max-height d-flex flex-column justify-content-between">
                                <div class="card-header py-3">
                                    <h2 class="card-title font-weight-300 mt-0">
                                        <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'PAGE_PERFORMANCE'] | monIcons" aria-hidden="true"></span>
                                        <span translate>Page Performance</span>
                                    </h2>
                                </div>
                                <div class="card-body">
                                    <page-details-dashboard-charts-page-performance [page]="page" (onClickHandler)="navigateTo($event.params)"></page-details-dashboard-charts-page-performance>
                                </div>
                                <div class="card-footer text-right bg-white">
                                    <a class="font-size-1-1" role="button" (click)="navigateTo({target: 'page-details-section-page-performance'})" translate>
                                        PAGE PERFORMANCE OVERVIEW
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-48 col-sm-24 pb-3" *ngIf="('dataprivacy' | domainActiveFeature:domain) && (authUser | hasAccess: modules.data_privacy)">
                            <div class="card panel-monsido-card mb-3 max-height d-flex flex-column justify-content-between">
                                <div class="card-header py-3">
                                    <h2 class="card-title font-weight-300 mt-0">
                                        <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'DATA_PRIVACY'] | monIcons" aria-hidden="true"></span>
                                        <span translate>Data Privacy</span>
                                    </h2>
                                </div>
                                <div class="card-body">
                                    <page-details-dashboard-charts-data-privacy [page]="page" (onClickHandler)="navigateTo($event.params)"></page-details-dashboard-charts-data-privacy>
                                </div>
                                <div class="card-footer text-right bg-white">
                                    <a class="font-size-1-1" role="button" (click)="navigateTo({target: 'page-details-section-data-privacy'})" translate>
                                        DATA PRIVACY OVERVIEW
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="col-48 pb-3">
                            <div class="card panel-monsido-card mb-0 max-height">
                                <div class="card-header py-3">
                                    <h2 class="card-title font-weight-300 mt-0">
                                        <span class="fa-lg fa-fw text-link fas fa-info-circle" aria-hidden="true"></span>
                                        <span translate>Scan Information</span>
                                    </h2>
                                </div>
                                <div class="card-body">
                                    <div class="row align-items-stretch">
                                        <div class="col-16 pb-3">
                                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Last Scan' | translate" icon="fas fa-redo">
                                                {{ page.lastcheck | userDate:'llll' }}
                                            </page-details-section-dashboard-blocks-overview>
                                        </div>
                                        <div class="col-16 pb-3">
                                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Robot Info' | translate" icon="fas fa-robot">
                                                <span [ngClass]="{ 'text-danger': page.no_index }">
                                                    {{ !page.no_index ? ('Index' | translate) : ('No index' | translate) }}
                                                </span>
                                            </page-details-section-dashboard-blocks-overview>
                                        </div>
                                        <div class="col-16 pb-3">
                                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Language Detected' | translate" icon="fas fa-language" [monTooltipText]="'Indicates which language this page will be scanned in. Click underneath to change' | translate">
                                                <span *ngIf="!showLanguageForm"
                                                      class="language-editable"
                                                      monEventTrigger="actionTrigger"
                                                      [monEventParams]="{action: 'page-detail-change-language'}"
                                                      (click)="showLanguageForm = !showLanguageForm">
                                                    {{ getLanguageName() }}
                                                </span>
                                                <div class="d-flex flex-wrap align-items-center"
                                                     (clickOutside)="showLanguageForm = false"
                                                     [delayClickOutsideInit]="true"
                                                     *ngIf="showLanguageForm">
                                                    <div class="pr-1">
                                                        <select [(ngModel)]="page.language" name="languageSelect">
                                                            <option [ngValue]="language.code" *ngFor="let language of languages; trackBy: trackByIndex">
                                                                {{language.name}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="pr-1">
                                                        <button type="button" class="btn btn-border-radius btn-secondary"
                                                                (click)="onUpdatePage()">
                                                            <span class="fa fa-check"></span>
                                                        </button>
                                                    </div>
                                                    <div>
                                                        <button type="button" (click)="showLanguageForm = !showLanguageForm"
                                                                class="btn btn-border-radius btn-inverse">
                                                            <span class="fa fa-times"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </page-details-section-dashboard-blocks-overview>
                                        </div>
                                        <div class="col-16 pb-3">
                                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Page first detected' | translate" icon="fas fa-clock">
                                                {{ page.created_at | userDate:'llll' }}
                                            </page-details-section-dashboard-blocks-overview>
                                        </div>
                                        <div class="col-16 pb-3">
                                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Word count' | translate" icon="fas fa-font">
                                                {{ page.readability_words_count | monNumber }}
                                            </page-details-section-dashboard-blocks-overview>
                                        </div>
                                        <div class="col-16 pb-3" *ngIf="'readability' | domainActiveFeature">
                                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Readability score' | translate" [icon]="['SIDEMENUES', 'QA', 'READABILITY'] | monIcons">
                                                <span class="readability-score">
                                                    {{ (page.readability || 0) | monNumber }}
                                                </span>
                                                {{page.readability_level | translateReadability:domain.features.readability_test}}
                                            </page-details-section-dashboard-blocks-overview>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Module Section END-->
                <!-- Statistics Section BEGIN-->
                <div class="col-48 col-lg-18" *ngIf="showStatistics && (authUser | hasAccess: modules.statistics)">
                    <div class="card panel-monsido-card d-flex flex-column justify-content-between">
                        <div class="card-header py-3">
                            <h2 class="card-title font-weight-300 mt-0">
                                <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'STATISTICS'] | monIcons" aria-hidden="true"></span>
                                <span translate>Analytics (Last 7 days)</span>
                            </h2>
                        </div>
                        <div class="card-body px-0 pt-0">
                            <div class="alert alert-info px-3 my-0 flat" *ngIf="'page_statistics' | hasDemoAccess" translate>
                                Statistics is using sample data
                            </div>
                            <page-details-dashboard-charts-statistics class="block px-4 mt-3" [page]="page">
                            </page-details-dashboard-charts-statistics>
                        </div>
                        <div class="card-footer text-right bg-white">
                            <a class="font-size-1-1" role="button" (click)="navigateTo({target: 'page-details-section-statistics'})" translate>
                                STATISTICS OVERVIEW
                            </a>
                        </div>
                    </div>
                </div>
                <!-- Statistics Section END-->
            </div>
        </div>
    `,
})
export class PageDetailsSectionDashboardComponent implements OnInit {
    @Input() page: any;
    @Input() languages: any;
    @Output() onClickHandler = new EventEmitter<any>();
    @Output() updatePage = new EventEmitter<any>();

    showLanguageForm: boolean = false;
    showStatistics: boolean = false;
    showAccessibility: boolean = false;
    showQA: boolean = false;
    showSEO: boolean = false;
    showPolicy: boolean = false;
    modules = MON_MODULES;
    authUser: any = null;
    loading: boolean = true;
    domain: any;

    constructor (
        private sessionService: SessionService,
        private loginService: LoginService,
        private activeFeatureService: ActiveFeatureService,
        private pipeService: PipeService,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.showLanguageForm = false;
        this.page = this.page || {};
        this.showStatistics = false;
        this.showAccessibility = false;
        this.showQA = this.activeFeatureService.isFeatureActivePure('qa_links') || this.activeFeatureService.isFeatureActivePure('qa_spellcheck');
        this.showSEO = this.activeFeatureService.isFeatureActivePure('seo_all');
        this.showPolicy = this.activeFeatureService.isFeatureActivePure('policies_all');
        this.authUser = null;
        this.loading = true;
        this.domain = this.sessionService.domain;

        this.loginService
            .getUser()
            .then((user: any) => {
                this.loading = false;
                this.authUser = user === null ? this.sessionService.me : user;
            }, () => {
                // Handle error
            })
            .finally(() => {
                if (this.sessionService.domain !== null) {
                    this.showStatistics = this.sessionService.domain.features.statistics || this.pipeService.get('monCustomerHasPlan')('demo');
                    this.showAccessibility = !!this.sessionService.domain?.features?.accessibility;
                }
            });
    }

    navigateTo (params: any): void {
        this.onClickHandler.emit({ params: params });
    }

    onUpdatePage (): void {
        this.showLanguageForm = false;
        this.updatePage.emit({ page: this.page });
    }

    getLanguageName (): string {
        if (this.page.language === null) {
            return this.translateService.getString('NA');
        }

        const index = this.languages?.findIndex((language: any) => {
            return language.code === this.page.language;
        });

        if (index === -1 || index === undefined) {
            return this.translateService.getString('NA');
        }

        return this.languages[index].name;
    }

    trackByIndex (index: number): number {
        return index;
    }
}
